import { forwardRef, useId } from "react";
import type { InputHTMLAttributes } from "react";

import { cn } from "./utils";

export interface CampoProps extends InputHTMLAttributes<HTMLInputElement> {
  etiqueta: string;
  ayuda?: string;
  error?: string;
}

export const Campo = forwardRef<HTMLInputElement, CampoProps>(function Campo(
  { etiqueta, ayuda, error, className, id, ...resto },
  ref,
) {
  const idGenerado = useId();
  const idCampo = id ?? idGenerado;
  const idAyuda = ayuda ? `${idCampo}-ayuda` : undefined;
  const idError = error ? `${idCampo}-error` : undefined;
  const describedBy = [idAyuda, idError].filter(Boolean).join(" ") || undefined;

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={idCampo} className="text-etiqueta text-texto">
        {etiqueta}
      </label>
      <input
        ref={ref}
        id={idCampo}
        aria-describedby={describedBy}
        aria-invalid={Boolean(error) || undefined}
        className={cn(
          "min-h-control rounded-control border border-borde bg-superficie px-3 text-cuerpo text-texto shadow-sm",
          "focus-visible:border-primario focus-visible:shadow-foco",
          "disabled:cursor-not-allowed disabled:bg-fondo disabled:text-texto-secundario/50",
          error && "border-peligro",
          className,
        )}
        {...resto}
      />
      {ayuda ? (
        <p id={idAyuda} className="text-nota text-texto-secundario">
          {ayuda}
        </p>
      ) : null}
      {error ? (
        <p id={idError} className="text-nota text-peligro" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
});
